import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Message, Attachment, User } from 'models';
import Avatar from 'shared/components/Avatar';
import MessageWithLinks from 'shared/components/MessageWithLinks';

import styles from './styles';
import { makeGetChatUserFromMessage } from '../../../app/ChatApp/selectors';

import ChatMessageWithAttachment from '../ChatMessageWithAttachment';

export class ChatMessageForUser extends PureComponent {
  renderMessageColumn() {
    const { message } = this.props;

    return (
      <p className="userMessage kustomer-app-thread-user-message" style={styles.message}>
        <MessageWithLinks text={message.body} markdown />
      </p>
    );
  }

  renderAvatarColumn() {
    const { user, hideAvatar } = this.props;

    if (hideAvatar) {
      return <div style={styles.emptyAvatar} />;
    }

    return (
      <div style={styles.userAvatar}>
        <Avatar avatarUrl={user.avatarUrl} defaultName={user.name} includeDefault={!hideAvatar} />
      </div>
    );
  }

  render() {
    const { attachment, message } = this.props;
    let style = styles.message;
    if (message.loading || message.failed) {
      style = Object.assign({}, style, styles.loading);
    }

    if (message.attachments && message.attachments.length) {
      return (
        <ChatMessageWithAttachment // eslint-disable-line
          attachment={attachment}
          className="userMessage"
          message={message}
          style={style}
        />
      );
    }

    return (
      <div style={styles.wrapper}>
        {this.renderAvatarColumn()}
        {this.renderMessageColumn()}
      </div>
    );
  }
}

ChatMessageForUser.propTypes = {
  message: React.PropTypes.instanceOf(Message),
  user: React.PropTypes.instanceOf(User),
  hideAvatar: React.PropTypes.bool,
  attachment: React.PropTypes.instanceOf(Attachment),
};

ChatMessageForUser.defaultProps = {
  message: Message(),
  user: User(),
  hideAvatar: false,
  attachment: Attachment(),
};

const mapStateToProps = () => {
  const getChatUserFromMessage = makeGetChatUserFromMessage();
  return (state, props) => ({
    user: getChatUserFromMessage(state, props),
  });
};

export default connect(mapStateToProps)(ChatMessageForUser);
